import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { Store } from 'store';
import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { HttpMethods } from 'api/types';
import { AppBundle } from 'api/optimalprint-sdk.d';
import setPricesToFetchOperation from 'store/price/operation/setPricesToFetchOperation';
import collectPricesFromProduct from 'utils/price/collectPricesFromProduct';
import { setCategoryIdAction } from 'store/category/slice';
import getCommonProductRequestParams from '../selector/getCommonProductRequestParams';
import {
  setEveryItemOutOfStockAction,
  setFetchedProductUidAction,
  setInitialProductFlagAction,
  setPersonalisedProductAction,
  setProductIdAction,
} from '../slice';
import getProductName from '../selector/getProductName';
import getProductUid from '../selector/getProductUid';
import getFetchedProductUid from '../selector/getFetchedProductUid';
import resetProductPageDataOperation from './resetProductPageDataOperation';
import { ExtendedProduct, STOCK_STATUS } from '../types';

const fetchPersonalisedProductOperation =
  () => async (dispatch: ThunkDispatch<Store, undefined, AnyAction>, getState: () => Store) => {
    const store = getState();
    const { locale } = getCommonProductRequestParams(store);
    const productName = getProductName(store);
    const productUid = getProductUid(store);
    const needToFetch = getFetchedProductUid(store) !== productUid;
    if (!needToFetch) return;
    const productData = (await apiRequest(
      endpoints.contentAppV1CreateProductPage,
      {
        productName,
        initialProductUid: productUid,
        isMobile: false,
        locale,
      },
      HttpMethods.GET,
      'data',
    )) as AppBundle.Api.Response.Content.V1.ContentAppCreateProductPageV1Response;

    const isEveryItemOutOfStock = productData.productPage.abstractProduct?.products?.every(
      (product: any & ExtendedProduct) => product?.avalilabilityStatus?.status === STOCK_STATUS.STATUS_UNAVAILABLE,
    );
    dispatch(setEveryItemOutOfStockAction(Boolean(isEveryItemOutOfStock)));
    dispatch(resetProductPageDataOperation());
    dispatch(setInitialProductFlagAction(true));

    dispatch(setFetchedProductUidAction(productUid));
    const prices = collectPricesFromProduct(
      productData.productPage?.abstractProduct?.products || [],
      productData.productPage?.abstractProduct?.categoryId || 1,
    );
    dispatch(setPricesToFetchOperation(prices));

    dispatch(setPersonalisedProductAction(productData.productPage));
    dispatch(setCategoryIdAction(productData.productPage.abstractProduct?.categoryId));
    dispatch(setProductIdAction(productData.productPage.abstractProduct?.initialProduct.productId || 0));
  };

export default fetchPersonalisedProductOperation;
